import React from 'react';
import { Box, Modal, Button } from "@mui/material";
import { Delete } from "@mui/icons-material";
import './DeleteRecordModal.css';

const DeleteRecordModal = ({ state = false, handleSubmit, classNames, onHide }) => {
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "background.paper",
        width: 400,
        border: "0",
        boxShadow: 0,
        p: 4,
    };
    return (
        <Modal
            open={state}
            onClose={onHide}
            className={classNames}
        >
            <Box sx={style}>
                <div className="alert-body">
                    <div className="alert-icon">
                        <Delete style={{ fontSize: "2rem" }} />
                    </div>
                    <h2> Are you sure? </h2>
                    <p> Do you really want to delete these records? This process cannot be undone. </p>
                </div>
                <div className="alert-footer-box">
                    <Button
                        fullWidth
                        variant="contained" 
                        color="inherit"                     
                        onClick={onHide}
                        style={{marginRight:15}}
                    >
                        Cancel
                    </Button>
                    <Button
                        fullWidth
                        variant="contained" color="error"
                        onClick={handleSubmit}
                    >
                        Delete
                    </Button>
                </div>
            </Box>
        </Modal>
    );
};

export default DeleteRecordModal;